import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLeaf,
  faStethoscope,
  faMoneyBill,
  faPencilSquare,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import { ThreeDots } from 'react-loader-spinner';
import { getEntitle, updateLeaveEntitlement } from "../../3.Store/LeaveEntitlementSlice";

const LeaveEntitlementList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const entitlements = useSelector((state) => state.LeaveEntitlementSlice.entitles);
  const [loading, setLoading] = useState(false);
  const role = JSON.parse(localStorage.getItem("roles"));

  useEffect(() => {
    setLoading(true);

    if (!role || !role.includes("HR-L-AWARD")) {
      localStorage.clear();
      window.location.href = "/Login";
    }

    dispatch(getEntitle())
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });

  }, [])

  const handleBtnBack = () => {
    navigate("/");
  };

  const handleBtnCreate = () => {
    navigate(`/EntitlementAdd`);
  };

  const handleClickView = (id) => {
    navigate(`/EntitlementForm/${id}`);
  };

  const renderEntitleList = () => {
    return entitlements.map(entitle => (
      <tr key={entitle?.id} style={{ cursor: "pointer" }}>
        <td>{entitle?.employee_catagory?.description}</td>
        <td>{entitle?.service_length?.description}</td>
        <td>{entitle?.annual}</td>
        <td>{entitle?.sick}</td>
        <td>{entitle?.medical}</td>
        <td onClick={() => handleClickView(entitle?.id)}>
          <FontAwesomeIcon icon={faPenToSquare} style={{ color: "blue" }} />
        </td>
      </tr>
    ));
  };

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Leave Entitlement</h1>
        <h1 className="MiniTitleHeader">List</h1>

        <div style={{ overflowX: 'auto' }}>
          <Table borderless className="mt-3 my-fixed-table text-center" style={{ fontSize: "14px", cursor: "pointer" }}>
            <thead>
              <tr>
                <th style={{ width: "120px" }}>Employee Category</th>
                <th style={{ width: "70px" }}>Service Length</th>
                <th style={{ width: "50px" }}>
                  <FontAwesomeIcon icon={faLeaf} title="Annual Leave" />
                </th>
                <th style={{ width: "50px" }}>
                  <FontAwesomeIcon icon={faStethoscope} title="Sick Leave" />
                </th>
                <th style={{ width: "50px" }}>
                  <FontAwesomeIcon icon={faMoneyBill} title="Medical Claim" />
                </th>
                <th style={{ width: "30px" }}>
                  <FontAwesomeIcon icon={faPencilSquare} title="Action" />
                </th>
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {entitlements.length > 0 ? (
                  renderEntitleList()
                ) : (
                  <tr>
                    <td colSpan="6">No results found</td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnCreate}>
              Add
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </div>
  );
};
export default LeaveEntitlementList;